// extracted by mini-css-extract-plugin
module.exports =  {"title":"title___rjyv2","chartWrapper":"chartWrapper___r6t9O","chartDescription":"chartDescription___PeDlS","description":"description___Cv2Ra"};